module.exports = __webpack_public_path__ + "18_pvis.jpg?a4a50f05a84768023876bd17dae5bfb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/18_pvis.jpg
// module id = 162
// module chunks = 0